module.exports = __webpack_public_path__ + "static/media/Morph_logo_mint.1f38fd50.png";